<template>
	<div class="mod-goods case">
		<div class="search">
			<el-input placeholder="请输入企业名称" v-model="searchText" size="mini" suffix-icon="el-icon-search" clearable @clear="getDataList()" @input="getDataList()"> </el-input>
		</div>
		<div class="info">
			<ul>
				<li v-for="(cnpy, index) of socList" :key="index" class="info-items">
					<a target="_blank" @click="goPage(cnpy)">
						<div class="Img">
							<img v-if="cnpy.imageUrl" :src="url + cnpy.imageUrl" />
							<img v-else src="@/assets/img/hd.jpg" />
							<i> {{ cnpy.deptName }} </i>
						</div>
						<div class="Txt">
							<h5>{{ cnpy.deptName }}</h5>
							<span :title="cnpy.introduct">{{ cnpy.introduct }}</span>
							<small style="background: #2962b0"></small>
						</div>
					</a>
				</li>
				<template v-if="socList.length % 4 == 2 || socList.length % 4 == 3">
					<li class="stand_p" v-for="item of 4 - (socList.length % 4)" :key="item + `${new Date()}`"></li>
				</template>
			</ul>
			<div class="mod-page">
				<pagination v-show="totalPage > 0" :total="totalPage" :page.sync="tablePage" :limit.sync="tableSize" @pagination="getDataList" />
			</div>
		</div>
	</div>
</template>

<script>
import Pagination from '@/components/Pagination'
export default {
	components: {
		Pagination,
	},
	data() {
		return {
			searchText: '',
			socList: [],
			tablePage: 1,
			tableSize: 10,
			totalPage: 0,
			url: window.SITE_CONFIG.baseUrl + '/checkmall-file/api/file/preview/',
		}
	},
	created() {
		this.getDataList()
	},
	methods: {
		goPage(cnpy) {
			console.log(window.location.protocol, 'window.location.protocol')
			if (window.location.protocol == 'http:') {
				console.log('bbbbbbbb')
				if (cnpy.url.includes('http://')) {
					let path = window.location.protocol + '//' + cnpy.url.split('//')[1]
					window.open(path, '_blank')
				} else if (cnpy.url.includes('https://')) {
					let path = cnpy.url.split('//')[0] + cnpy.url.split('//')[1]
					window.open(path, '_blank')
				} else {
					let path = window.location.protocol + '//' + cnpy.url
					window.open(path, '_blank')
				}
			}

			if (window.location.protocol == 'https:') {
				if (cnpy.url.includes('https://')) {
					let path = window.location.protocol + '//' + cnpy.url.split('//')[1]
					window.open(path, '_blank')
				} else if (cnpy.url.includes('http://')) {
					let path = cnpy.url.split('//')[0] + cnpy.url.split('//')[1]
					window.open(path, '_blank')
				} else {
					let path = window.location.protocol + '//' + cnpy.url
					window.open(path, '_blank')
				}
			}
		},
		getDataList() {
			let params = {
				current: this.tablePage,
				size: this.tableSize,
				data: {
					deptName: this.searchText,
				},
			}
			this.$http.post(this.$api.goodsApi.othereqList, params).then(({ data }) => {
				this.socList = data.data.list
				this.totalPage = data.data.total
			})
		},
	},
}
</script>

<style lang="scss" scoped>
.mod-goods {
	.search {
		position: absolute;
		right: 36px;
		top: 8px;
	}
}

.info-items{
	box-shadow: 0px 1px 28px 1px rgba(0, 0, 0, 0.04);
	border-radius: 10px;
}
.Img{
	border-radius: 10px 10px 0 0;
}
.case .info ul {
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	justify-content: space-between;
	overflow: auto;
	width: 100%;
	position: relative;
	font-size: 0;
}

.case .info li {
	display: inline-block;
	position: relative;
	width: 24%;
	margin: 0;
	margin-bottom: 15px;
	vertical-align: top;
}
.case .info li.stand_p {
	background: transparent !important;
	box-shadow: none !important;
}

.case .info li:nth-child(4n) {
	margin-right: 0;
}

.case .info li .Img {
	position: relative;
	overflow: hidden;
}

.case .info li .Img i {
	position: absolute;
	background: rgba(255, 255, 255, 0.9);
	text-align: center;
	bottom: 0;
	color: #000;
	font-size: 17px;
	font-weight: bold;
	width: 100%;
	height: 70px;
	line-height: 70px;
	display: block;
	transform: translateY(100%);
	-moz-transform: translateY(100%);
	-webkit-transform: translateY(100%);
	transition: all 0.4s ease-out;
	-moz-transition: all 0.4s ease-out;
	-webkit-transition: all 0.4s ease-out;
}

.case .info li .Img i img {
	max-width: 100%;
	max-height: 100%;
}
.case .info li .Img {
	display: block;
	width: 100%;
	overflow: hidden;
}

.case .info li .Img > img {
	display: block;
	width: 100%;
	height: auto;
	transition: all 1.2s ease-in-out;
	width: 220px;
  height: 124px;
}

.case .info li .Txt {
	height: 70px;
	overflow: hidden;
	width: 100%;
	position: relative;
	text-align: center;
	overflow: hidden;
	z-index: 2;
}

.case .info li .Txt h5 {
	font-size: 15px;
	line-height: 1.5;
	padding-top: 15px;
	color: #000;
	transition: all 0.5s ease-in-out;
	font-weight: initial;
	overflow: hidden;
	height: 42px;
	margin: 0;
}

.case .info li .Txt span {
	font-size: 13px;
	color: #999;
	font-style: oblique;
	transition: all 0.5s ease-in-out;
}

.case .info li:hover .Txt h5 {
	color: #fff;
	opacity: 0;
	transform: translateY(-100%);
	height: 25px;
	margin: 0;
}

.case .info li:hover .Txt span {
	color: #fff;
}

.case .info li .Txt small {
	display: block;
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: -1;
	transform: translateY(-100%);
	transition: all 0.4s ease-in-out 0.2s;
}

.case .info li:hover .Img i,
.case .info li:hover .Txt small {
	transform: translate(0);
	-moz-transform: translate(0);
	-webkit-transform: translate(0);
	opacity: 1;
}

.case .info li:hover .Img > img {
	transform: scale(1.1);
	-moz-transform: scale(1.1);
	-webkit-transform: scale(1.1);
}
@media only screen and (max-width: 1440px) {
	.case .info li .Txt h5 {
		font-size: 14px;
	}

	.case .info li .Txt span {
		font-size: 12px;
	}
}
</style>
